import { z } from 'zod';

export const errorResponseSchema = z.object({
  message: z.string(),
  clientError: z.string().optional(),
  status: z.number().optional(),
});

export type ErrorResponse = z.infer<typeof errorResponseSchema>;
